import { render, staticRenderFns } from "./building.vue?vue&type=template&id=874704b2&scoped=true"
import script from "./building.vue?vue&type=script&lang=ts"
export * from "./building.vue?vue&type=script&lang=ts"
import style0 from "./building.vue?vue&type=style&index=0&id=874704b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874704b2",
  null
  
)

export default component.exports